import { render, staticRenderFns } from "./company_search.vue?vue&type=template&id=f955b6bc&scoped=true"
import script from "./company_search.vue?vue&type=script&lang=js"
export * from "./company_search.vue?vue&type=script&lang=js"
import style0 from "./company_search.vue?vue&type=style&index=0&id=f955b6bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f955b6bc",
  null
  
)

export default component.exports